<template>
  <div class="errSummary">
    <headers
      style="position: fixed; width: 100%; z-index: 999"
      class="herderNav"
      ref="header"
      :isChange="false"
    />
    <!-- 答题情况总结 -->
    <div class="summaryCard">
      <div class="summaryTit">答题情况总结</div>
      <div class="summaryTitCon">
        <div class="summaryTitConFirst">
          <img src="../../assets/allSubject/userPicture.png" />
        </div>
        <div class="summaryTitConSecond">
          <p class="firstTit">答对题数</p>
          <el-progress
            type="circle"
            :percentage="75"
            :format="format"
            color="#5191ff"
          ></el-progress>
          <p class="gradeInfos">平均练习结果：20/18</p>
        </div>
        <div class="summaryTitConSecond">
          <p class="firstTit">做题时间</p>
          <el-progress
            type="circle"
            :percentage="75"
            :format="formatTimer"
            color="#3ec4ff"
          ></el-progress>
          <p class="gradeInfos">平均做题时间：26min49m</p>
        </div>
      </div>
    </div>
    <div class="summaryContent">
      <div class="summaryConTits"><h1>答案及解析</h1></div>
      <div class="summaryConTitle">
        <ul>
          <li
            v-for="(ele, index) in ConTitle"
            :key="index"
            @click="switchTit(ele.type)"
            :class="n == ele.type ? 'activeTit' : ''"
          >
            {{ ele.tit }}
          </li>
        </ul>
      </div>
      <div class="allSubject">
        <div v-for="ele in 20" :key="ele" @click="analysis">1</div>
      </div>
      <div class="summaryConTits titInfos"><h1>题目信息</h1></div>
      <div class="titCards">
        <p class="titCardsTit">题目</p>
        <div>
          伊丽莎白·卡迪·斯坦顿（Elizabeth Cady
          Stanton）担任短暂的妇女州禁酒协会（1852-1853）的主席期间，坚决主张实行自由化的离婚法，令许多最热心的支持者感到震惊，因为她建议应将醉酒作为充分的理由离婚一个因为她的自由化离婚法的坚定倡导者，反感她的许多最热心的支持者在她的建议，醉酒应该是
        </div>
        <p class="siwtchFirst">
          A
          坚决主张实行自由化的离婚法，并以醉酒的暗示使许多最热心的支持者感到震惊
        </p>
        <p>
          B
          坚决主张实行自由化的离婚法，并以醉酒的暗示使许多最热心的支持者感到震惊
        </p>
        <p>
          C
          坚决主张实行自由化的离婚法，并以醉酒的暗示使许多最热心的支持者感到震惊
        </p>
        <p>
          D
          坚决主张实行自由化的离婚法，并以醉酒的暗示使许多最热心的支持者感到震惊
        </p>
        <P class="siwtchFirst">正确答案 : A</P>
        <P class="siwtchFirst">我的答案 : B</P>
      </div>
      <div class="titCardsTwo">
        <div class="titCardsTwoCon">
          <p class="titCardsTwoTits">【缺点等级】</p>
          <p>★☆☆☆☆「较易」对应550以下分数段，本题平均正确替换81％</p>
          <p class="titCardsTwoTits">【正选结构】</p>
          <p>…伊丽莎白·卡迪·斯坦顿…使…的支持者感到震惊</p>
          <p class="titCardsTwoTits">【正选翻译】</p>
          <p>
            在她短暂的妇女国家禁酒协会（1852-1853）会长任期，Elizabeth Cady
            Stanton，一位坚定的离婚自由法支持者，使很多他的最热心的支持者感到震惊，她建议：醉酒逐渐成为离婚的理由。
          </p>
          <p class="titCardsTwoTits">【知识要点】</p>
          <div>
            <p>1, 虚拟语气</p>
            <p>
              表示建议，命令，要求的虚拟语言气中，无论是动词还是名词，其后的应该要省略。因此建议后面一定不会出现应该，而应该出现的是动词原型
            </p>
          </div>
        </div>
      </div>
      <!-- 提供解析的用户  -->
      <div class="analysisUser">
        <div class="analysisUserNav">
          <h2>提供解析的用户</h2>
          <p>由jksahdash老师审核</p>
        </div>
        <div class="analysisUserCon">
          <img
            v-for="ele in 5"
            :key="ele"
            src="../../assets/allSubject/userPicture.png"
          />
        </div>
        <!-- 题目讨论 -->
        <div class="analysisDiscussNav">
          <div class="analysisUserNav"><h2>题目讨论</h2></div>
          <div class="analysisDiscussUser">
            <img src="../../assets/allSubject/userPicture.png" />
            <p class="userNickname">画画撒大针对SC题目</p>
            <p>已输入{{ userInputScore }}个字</p>
          </div>
          <textarea
            type="text"
            class="inputs"
            v-model="userInput"
            placeholder="我要讨论/提问  (限400字)"
            maxlength="400"
          />
          <div class="userBtns">
            <el-checkbox v-model="checked" radio
              >标记为提问，会有更大神为你解答</el-checkbox
            >
            <button @click="reportBtn">发送</button>
          </div>
        </div>
      </div>
      <div class="summaryConTits titInfos">
        <h1>解析说明</h1>
      </div>
      <div class="Explanation">
        <h2>如何使用解析使自己变强</h2>
        <div class="ExplanationInfo">
          <p>
            1、定位到自己做错的题目，结合考点和句子结构分析做错的原因，深入理解
          </p>
          <p>
            2、定位到自己做错的题目，结合考点和句子结构分析做错的原因，深入理解
          </p>
          <p>
            3、定位到自己做错的题目，结合考点和句子结构分析做错的原因，深入理解
          </p>
          <p>
            4、定位到自己做错的题目，结合考点和句子结构分析做错的原因，深入理解
          </p>
        </div>
        <p class="proposal">
          建议：因为Gmat考试主要考察考生的逻辑思维能力，建议大家每题一定要深入研究理解题目考点，早日提升到以不变应百变的题目理解能力~
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import headers from "../../components/header.vue";
export default {
  components: {
    headers,
  },
  data() {
    return {
      navCodes: require("@/assets/login/navCode.png"),
      herderTits: {
        color: "#666666",
      },
      headerBack: {
        background: "#ffffff",
      },
      headerIcon: require("@/assets/home/headerNav.png"),
      n: 1,
      ConTitle: [
        { tit: "全部题目", type: 1 },
        { tit: "错题", type: 2 },
        { tit: "耗时长的题目", type: 3 },
      ],
      checked: false,
      //用户输入
      userInput: "",
      userInputScore: 0,
    };
  },
  methods: {
    format(percentage) {
      if (percentage) {
        return "15/20";
      }
    },
    formatTimer(percentage) {
      if (percentage) {
        return "45min25s";
      }
    },
    switchTit(type) {
      this.n = type;
    },
    analysis() {
      this.$router.push("/libraryContent");
    },
    //评论发送
    reportBtn() {
      if (localStorage.getItem("token")) {
        console.log("发表评论");
      } else if (localStorage.getItem("token")) {
        console.log("发表评论");
      } else {
        setTimeout(() => {
          this.$router.push("/");
        }, 2000);
      }
    },
  },
  mounted() {
    this.$refs.header.headerBack = {
      backgroundColor: "#fff",
    };
    this.$refs.header.herderTits = {
      color: "rgb(102,102,102)",
    };
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    // api.baseParams().then(res => {
    //   console.log(res)
    // })
  },
  watch: {
    userInput(oldVal, newVal) {
      this.userInputScore = oldVal.length;
    },
  },
  // watch:{
  //   userInput(newVal,oldVal){
  //     this.userInputScore = newVal.length
  //   }
  // }
};
</script>

<style scoped>
@import url("../../assets/css/errSummary.css");
</style>



// WEBPACK FOOTER //
// src/view/questionBank/errSummary.vue